import type { Currency, PromotionLineItem } from '@weft/types';
import { getPromotionConfigDefaultValue } from 'apps/app/src/hooks/use-promotions-config-default-value';
import { generatePromotionTitle } from 'apps/app/src/services/promotions-formatter';
import React from 'react';
import { InvoiceSectionHeader } from './InvoiceSectionHeader';

type InvoicePromotionsProps = {
  promotionLineItems: PromotionLineItem[]
  currency: Currency
};

export const InvoicePromotions:React.FC<InvoicePromotionsProps> = ({
  promotionLineItems,
  currency,
}) => {
  return (
    <div className="mt-10">
      <div className="text-title mb-4 text-base">Promotions</div>
      <div className="space-y-5">
        {promotionLineItems.map((lineItem) => {
          const { deductedAmount, promotionModel } = lineItem.lineItemPromotion;
          const { promotionType, promotionConfiguration } = promotionModel;
          const amount = getPromotionConfigDefaultValue(promotionConfiguration, promotionType);

          return (
            <div
              className="rounded-2lg border-line border p-5"
              key={lineItem.id}
            >
              <InvoiceSectionHeader
                name={lineItem.lineItemPromotion.name}
                description={generatePromotionTitle(promotionType, amount)}
                price={deductedAmount}
                currency={currency}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};